/**
 * "Status prüfen" an einer Nachricht mit "Zustellung läuft" (Kundenfeedback
 * 02.10.2026, I.): fragt den Versanddienst nach dem aktuellen Zustand und
 * liefert die neue Zusammenfassung. Rückmeldung an den Anwender per Snackbar;
 * die Einordnung in den Verlauf übernimmt der Aufrufer.
 */
import { ref } from 'vue'
import { gt } from '@/i18n/gt'
import { type MessageDeliverySummary, refreshDelivery } from '@/services/deliveryApi'
import { useSnackbarStore } from '@/stores/snackbarStore'

export function useDeliveryRefresh () {
  const snackbar = useSnackbarStore()
  /** ID der Nachricht, deren Status gerade abgefragt wird (Spinner am Knopf). */
  const refreshingId = ref<number | null>(null)

  async function refresh (idMessage: number): Promise<MessageDeliverySummary | null> {
    if (!idMessage || refreshingId.value !== null) return null
    refreshingId.value = idMessage
    try {
      const summary = await refreshDelivery(idMessage)
      snackbar.showSuccess(gt('Zustellstatus aktualisiert'))
      return summary
    } catch (error) {
      snackbar.showError((error as Error)?.message || gt('Der Zustellstatus konnte nicht geprüft werden.'))
      return null
    } finally {
      refreshingId.value = null
    }
  }

  return { refreshingId, refresh }
}
